import { ContentSection2UpLg, Stage } from "components/layout";
import React from "react";
import { CustomReportsQuery } from "./custom-reports/custom-reports-query";
import { CustomReportsSidebar } from "./custom-reports/custom-reports-sidebar";

export const CustomReports: React.FC = () => {
    return (
        <Stage>
            <ContentSection2UpLg>
                <CustomReportsSidebar />
                <CustomReportsQuery />
            </ContentSection2UpLg>
        </Stage>
    );
};
